import React from 'react';
import { useEffect, useState } from "react";
import { getAllData, postUsersData, patchUsersData, verifytoken } from '../../../services/ApiCallingUserServices';
import Switch from 'react-switch';
import { alphaNumericspace, formatDateRequire, generatePDF } from '../../commonClass/CommonValidation';
import { useNavigate } from 'react-router-dom';
import { ClearLocalStorage, GetLocalStorage } from '../../commonClass/Session';
import { useDispatch, useSelector } from "react-redux";
import { loaderActions } from "../../../_actions/loader.actions";
import { ConfirmationModal } from '../../../customControl/ConfirmationModal';
import { ExportExcel } from '../../commonClass/ExportExcel';
import Role from './Role';
import { DepartmentModel } from '../modals/RightsModel';
import CustomTable from '../../../customControl/CustomTable';
import CommonFilter from '../../../customControl/CommonFilter';

const Department = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [formErrors, setFormErrors] = useState<any>({});
    const [buttonaddeditText, setButtonAddEditText] = useState("Add");
    const [editdisabled, setEditDisabled] = useState(true);
    const [modalShow, setModalShow] = useState(false);
    const [disabled, setDisabled] = useState(false);

    const [departmentdata, setDepartmentData] = useState<any>([]);
    const [filteritems, setFilterItems] = useState<any>([]);

    const [useredit, setUserEdit] = useState(true);
    const [useradd, setUserAdd] = useState(true);
    const [userexport, setUserExport] = useState(true);
    const user = useSelector((store: any) => store.userstatus.tba);
    const menuItem = useSelector((store: any) => store.menuitems.menu);
    const [isSubmit, setIsSubmit] = useState(false);
    const [form, setForm] = useState(new DepartmentModel());

    const [searchvalue, setSearchValue] = useState('');
    const [searchby, setSerachBy] = useState<any>('All');


    const onSubmitForm = (e: any) => {
        e.preventDefault();
        setFormErrors(validate(form));
    };

    const handleisActive = (e: any) => {
        if (buttonaddeditText === 'Add') {
            form.IsActive = e
            setFormErrors('');
        }
        else {
            setModalShow(true);
        }
    }

    const handleConfirmation = (e: any) => {
        if (e === true) {
            form.IsActive = !form?.IsActive
            setEditDisabled(true);
            setFormErrors('');
        }
        setModalShow(false);
    }

    //#region bind datatable

    const columns: any = [
        {
            name: 'Department Name',
            key: 'DepartmentName',
            sortable: true,
            reorder: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (department: any) => department?.DepartmentName
        },

        {
            name: 'Status',
            key: 'Active',
            sortable: true,
            reorder: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (department: any) => department?.Active
        },
        {
            name: 'Created Date',
            sortable: true,
            reorder: true,
            float: "left",
            isSearch: false,
            isExport: false,
            selector: (department: any) => new Date(department?.CreatedOn),
            format: (department: any) => department?.CreatedDate
        },
        {
            name: 'Edit',
            selector: (department: any) => <button type='button' className='border-0 p-0 bg-transparent set_disableclr' disabled={!useredit || department?.IsReadOnly}><i className="fa-regular fa-pen-to-square" onClick={() => handleEditMode(department.DepartmentId)}></i></button>
        },
        {
            name: 'View',
            selector: (department: any) => <button type='button' className='border-0 p-0 bg-transparent set_disableclr'><i className="fa-regular fa-eye" onClick={() => handleViewMode(department.DepartmentId)} ></i></button>
        }
    ];

    //#endregion

    //#region handling search

    useEffect(() => {
        dispatch(loaderActions.start());
        getdepartmentlist();
    }, []);

    useEffect(() => {
        let pagelink = user?.find((x: any) => {
            if (x?.PageLink === window.location.pathname)
                return x?.MenuId
        });
        let mid = user?.find((x: any) => x?.MenuId === pagelink?.MenuId);
        if (mid?.URightView === false && mid?.URightView !== undefined) {
            navigate('/dashboard');
        }
        user?.filter((x: any) => x?.MenuId === pagelink?.MenuId).map((obj: any) => {
            setUserAdd(obj?.URightAdd);
            setUserEdit(obj?.URightEdit);
            setUserExport(obj?.URightExport);

        });
    }, [user])
    //#endregion

    const getdepartmentlist = async () => {
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            await getAllData('/auth/v1/getalluserdepartment?UserType=' + form.UserType).then((departmentdata) => {
                departmentdata.data?.map((obj: any) => {
                    obj.Active = obj.IsActive ? 'Active' : 'InActive'
                    obj.CreatedDate = formatDateRequire(obj?.CreatedOn)
                    return obj;
                })
                setDepartmentData(departmentdata.data);
                setFilterItems(departmentdata.data);
                dispatch(loaderActions.end());
            });
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
    }

    const handleEditMode = (id: any) => {
        setDisabled(false);
        setButtonAddEditText("Update");
        setSerachDisable(true);
        RetriveData(id);
        setEditDisabled(false);
    }

    const handleViewMode = (id: any) => {
        setDisabled(true);
        setEditDisabled(false);
        setSerachDisable(true);
        RetriveData(id);
    }

    function RetriveData(id: any) {
        setFormErrors('');
        departmentdata?.map((obj: any) => {
            if (obj.DepartmentId === id) {
                setForm({ ...form, DepartmentId: obj.DepartmentId, DepartmentName: obj.DepartmentName, IsActive: obj.IsActive })
            }
        });

    }

    const validate = (values: any) => {
        setIsSubmit(true);
        const error: any = {}
        if (!values.DepartmentName || values.DepartmentName?.trim()?.length === 0) {
            error.DepartmentName = "Kindly enter the department name";
            setIsSubmit(false);
        }
        return error;
    }

    const handleSubmitData = async () => {
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            let user: any = GetLocalStorage();
            form.UserId = user?.userMasterID
            const DepartmentData = buttonaddeditText === 'Add' ? await postUsersData('/auth/v1/insertuserdepartment', form)
                : await patchUsersData('/auth/v1/updateuserdepartment', form)
            const status = DepartmentData.status;
            if (!DepartmentData.status && !DepartmentData.data) {
                dispatch({ type: 'ALERTING', message: DepartmentData.message });
                setDisabled(false);
                setEditDisabled(true);
                setIsSubmit(false);
                return;
            }
            if (status) {
                dispatch({ type: 'ALERTING', message: DepartmentData.message });
                clear();
            }
            else {
                dispatch({ type: 'ALERTING', message: DepartmentData.message })
                setDisabled(false);
                setEditDisabled(true);
                return;
            }
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }

    }

    useEffect(() => {
        if (Object.keys(formErrors)?.length === 0 && isSubmit) {
            setDisabled(true);
            setEditDisabled(false);
            handleSubmitData();
        }
        if (Object.keys(formErrors).length > 0) {

            let id = Object.keys(formErrors)[0];
            if (id === "LocationId") {
                eval(id).current.focus();
            }
            else {
                let doc = document.getElementById(id);
                if (doc !== null)
                    doc.focus();
            }
        }

    }, [formErrors]);

    const onChange = (e: any) => {
        var result;
        if ([e.target.name][0] === 'DepartmentName') {
            result = alphaNumericspace(e.target.value)
        }
        else {
            result = e.target.value;
        }
        setForm({ ...form, [e.target.name]: result });
        setEditDisabled(true);
        setFormErrors('');
    }

    const handleClearClick = () => {
        clear();
    }

    function clear() {
        setButtonAddEditText('Add');
        setIsSubmit(false);
        setDisabled(false);
        setFormErrors('');
        setForm({
            ...form, DepartmentName: '', IsActive: false, DepartmentId: 0,
        });
        getdepartmentlist();
        setEditDisabled(true);
        setSerachDisable(false);
        setSearchValue('');
        setSerachBy('All')
    }

    //#region filter
    const [serchdisable, setSerachDisable] = useState(false);
    function formatDate(date: any) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [day, month, year].join('/');
    }

    //#endregion
    //#region Export
    const PdfExport = () => {
        const columns = [
            'Department Name', 'Status', 'Created Date'
        ];
        var rows: any = [];

        for (let i = 0; i < departmentdata.length; i++) {
            var temp = [
                departmentdata[i].DepartmentName,
                `${departmentdata[i].IsActive ? 'Active' : 'InActive'}`,
                formatDate(departmentdata[i].CreatedOn)
            ];
            rows = [...rows, temp]
        }
        generatePDF(columns, rows, "DepartmentList", "Department List")
    }
    const ExportToExcel = () => {
        const dispalyname = ['Department Name', 'Status', 'Created Date'];
        const fields = ['DepartmentName', 'IsActive', 'CreatedOn'];
        ExportExcel(dispalyname, fields, departmentdata, "DepartmentList", "DepartmentList.xls");
    }
    //#endregion Export


    return (
        <>
            <div className="mx-2 mt-0 mb-3 heading_color">
                <h2 className='fw-bold'>{menuItem?.[0]?.pageTitle}</h2>
            </div>
            <div className="m-2 heading_color">
                <h4>{menuItem?.[1]?.pageTitle} </h4>
            </div>
            <div className="m-2">
                <div className='container mt-3 mb-5 tab_section px-0'>
                    <ul className="nav nav-pills nav-justified mb-3 pt-3 col-lg-3 col-12 mx-auto" id="pills-tab" role="tablist">
                        <li className="nav-item mt-1 mx-1" role="presentation">
                            <button className="nav-link active" id="pills-Department-tab" data-bs-toggle="pill"
                                data-bs-target="#pills-Department" type="button" role="tab" aria-controls="pills-about"
                                aria-selected="true">Department</button>
                        </li>
                        <li className="nav-item mt-1 mx-1" role="presentation" >
                            <button className="nav-link" id="pills-Role-tab" data-bs-toggle="pill"
                                data-bs-target="#pills-Role" type="button" role="tab" aria-controls="pills-tips"
                                aria-selected="false">Role</button>
                        </li>
                    </ul>
                </div>
                <div className="tab-content" id="pills-tabContent">
                    <div className="tab-pane fade show active" id="pills-Department" role="tabpanel"
                        aria-labelledby="pills-Department-tab">
                        <form action="" >
                            <div className="mb-1 row mx-1">
                                <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
                                    <div className="row">
                                        <div className="col-lg-4 col-md-12 col-sm-12">
                                            <label htmlFor="inputPassword6" className="col-form-label required">Department Name</label>
                                        </div>
                                        <div className=" col-lg-8 col-md-12 col-sm-12">
                                            <input className="form-control"
                                                type="text"
                                                id='DepartmentName'
                                                name="DepartmentName"
                                                value={form.DepartmentName}
                                                onChange={onChange}
                                                disabled={disabled ? true : false}
                                                placeholder='Department Name'
                                                maxLength={35}
                                            />
                                            {formErrors.DepartmentName && <div className='text-danger text-start fs_14'>{formErrors.DepartmentName}</div>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
                                    <div className="row">
                                        <div className="col-lg-4 col-md-12 col-sm-12">
                                            <label htmlFor="inputPassword6" className="col-form-label">Active</label>
                                        </div>
                                        <div className="col-auto col-lg-6">
                                            <Switch
                                                onChange={handleisActive}
                                                checked={form?.IsActive}
                                                className="react-switch"
                                                disabled={disabled ? true : false}
                                            />
                                        </div>
                                        <ConfirmationModal
                                            show={modalShow}
                                            onHide={() => setModalShow(false)}
                                            noconfirm={() => handleConfirmation(false)}
                                            yesconfirm={() => handleConfirmation(true)}
                                        />

                                    </div>
                                </div>
                            </div>
                            <div className="mt-3 d-flex justify-content-center">
                                {useradd === false && buttonaddeditText === "Add" ?
                                    <button type="button" className="btn btn-primary mx-1" id="btnAdd" onClick={onSubmitForm} disabled={!useradd}>{buttonaddeditText}</button> :
                                    <button type="button" className="btn btn-primary mx-1" id="btnAdd" onClick={onSubmitForm} disabled={editdisabled ? false : true}>{buttonaddeditText}</button>}
                                <button type="button" className="btn btn-primary mx-1" id="btnClear" onClick={handleClearClick}>Clear</button>
                            </div>
                            <CommonFilter
                                filtercolumns={columns}
                                filteritems={filteritems}
                                setFilterList={setDepartmentData}
                                getdata={getdepartmentlist}
                                serchdisable={serchdisable}
                                setSearchValue={setSearchValue}
                                searchvalue={searchvalue}
                                setSerachBy={setSerachBy}
                                searchby={searchby}
                            />
                            <CustomTable
                                className={'last_two_column_freeze'}
                                columns={columns}
                                data={departmentdata}
                                PdfExport={false}
                                ExportToExcel={false}
                                disabled={!userexport}
                            />
                        </form>
                    </div>
                    <div className="tab-pane fade show" id="pills-Role" role="tabpanel"
                        aria-labelledby="pills-Role-tab">
                        <Role />
                    </div>
                </div>
            </div>
        </>
    )
}

export default Department